import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

//react
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Switch } from "react-router-dom";

//msal
// import { MsalProvider } from "@azure/msal-react";

//page
import Overlay from "IZOX/ARCS/Overlay/Overlay";
import { Denied, NoMatch, Landing, StartUp } from "IZOX/ARCS/Default";

//css
import "./index.css";
import "./preset.css";

//others
import * as serviceWorker from "./serviceWorker";

//tests
import {
  CalendarizoTest
} from "IZOX/BLOCKS/Labs/__TEST";

//GState
import { GState } from "IZOX/STATIC";
import Container from "__SYSDefault/Container/Container";
import PIndex from "Pages/Public/PIndex/PIndex";
import PPayment from "Pages/Public/PPayment/PPayment";
import PConfirmPolicy from "Pages/Public/PConfirmPolicy/PConfirmPolicy";
import PContactUs from "Pages/Public/PContactUs/PContactUs";
import PGeneralInsurance from "Pages/Public/PGeneralInsurance/PGeneralInsurance";
import PTandC from "Pages/Public/PTandC/PTandC";
import PRegister from "Pages/PUser/PRegister/PRegister";
import MarkdownTest from "IZOX/Tests/Markdown/MarkdownTest";
import PLogin from "Pages/PUser/PLogin/PLogin";
import PRedirect from "Pages/LoggedUser/PRedirect/PRedirect";
import PLogout from "Pages/Public/PLogout/PLogout";
import PForgotPassword from "Pages/PUser/PForgotPassword/PForgotPassword";
import PLocked from "Pages/LoggedUser/PRedirect/_gears/PLocked/PLocked";
import PDenied from "Pages/LoggedUser/PRedirect/_gears/PDenied/PDenied";
import PApplying from "Pages/LoggedUser/PRedirect/_gears/PApplying/PApplying";
import PVerifying from "Pages/LoggedUser/PRedirect/_gears/PVerifying/PVerifying";
import PRejected from "Pages/LoggedUser/PRedirect/_gears/PRejected/PRejected";
import PPendingToApprove from "Pages/LoggedUser/PRedirect/_gears/PPendingToApprove/PPendingToApprove";
import PAgentProfile from "Pages/LoggedUser/Agent/PAgentProfile/PAgentProfile";
import PDCProfile from "Pages/LoggedUser/DC/PDCProfile/PDCProfile";
import PADashboard from "Pages/LoggedUser/Agent/PADashboard/PADashboard";
import PAAllPolicies from "Pages/LoggedUser/Agent/PAAllPolicies/PAAllPolicies";
import PAAcountInfo from "Pages/LoggedUser/Agent/PAAccountInfo/PAAcountInfo";
import PAClaims from "Pages/LoggedUser/Agent/PAClaims/PAClaims";
import PAClientManage from "Pages/LoggedUser/Agent/PAClientManage/PAClientManage";
import PAMaidManage from "Pages/LoggedUser/Agent/PAMaidManage/PAMaidManage";
import PChangePassword from "Pages/LoggedUser/PChangePassword/PChangePassword";
import PIDashboard from "Pages/LoggedUser/Insurer/PIDashboard/PIDashboard";
import PIAllPolicies from "Pages/LoggedUser/Insurer/PIAllPolicies/PIAllPolicies";
import PIClaims from "Pages/LoggedUser/Insurer/PIClaims/PIClaims";
import PDCDashboard from "Pages/LoggedUser/DC/PDCDashboard/PDCDashboard";
import PDCAllPolicies from "Pages/LoggedUser/DC/PDCAllPolicies/PDCAllPolicies";
import PDCAcountInfo from "Pages/LoggedUser/DC/PDCAccountInfo/PDCAcountInfo";
import PDCClaims from "Pages/LoggedUser/DC/PDCClaims/PDCClaims";
import PAMonthlyPayment from "Pages/LoggedUser/Agent/PAMonthlyPayment/PAMonthlyPayment";
import PAACP from "Pages/LoggedUser/Agent/PAACP/PAACP";
// import PDCMaidManage from "Pages/LoggedUser/DC/PDCMaidManage/PDCMaidManage";
// import { pca } from "authConfig";

//pages


//mute the console on production launch
if (process.env.NODE_ENV === "production") {
  window.console.log = () => {};
}

// GState.setMSAL(pca) 
/**
 * 
 * @returns {Route[]}
 */
function renderPages() {
  return [
    <Route key={0} path="/Home" exact component={PIndex} />,
    <Route key={1} path="/Payment" exact component={PPayment} />,
    <Route key={2} path="/ContactUs" exact component={PContactUs} />,
    <Route key={3} path="/GeneralInsurance" exact component={PGeneralInsurance} />,
    <Route key={4} path="/TandC" exact component={PTandC} />,
    <Route key={5} path="/Register" exact component={PRegister} />,
    <Route key={6} path="/Login" exact component={PLogin} />,
    <Route key={7} path="/Logout" exact component={PLogout} />,
    <Route key={8} path="/ForgotPassword" exact component={PForgotPassword} />,
    <Route key={9} path="/User/Redirect" exact component={PRedirect} />,
    <Route key={10} path="/User/Locked" exact component={PLocked} />,
    <Route key={11} path="/User/Denied" exact component={PDenied} />,
    <Route key={12} path="/User/Applying" exact component={PApplying} />,
    <Route key={13} path="/User/Verifying" exact component={PVerifying} />,
    <Route key={14} path="/User/Rejected" exact component={PRejected}/>,
    <Route key={15} path="/User/PendingToApprove" exact component={PPendingToApprove}/>,
    <Route key={16} path="/Agent/Profile" exact component={PAgentProfile}/>,
    <Route key={18} path="/Agent/Dashboard" exact component={PADashboard}/>,
    <Route key={19} path="/Agent/AllPolicies" exact component={PAAllPolicies}/>,
    <Route key={20} path="/Agent/AccountInfo" exact component={PAAcountInfo}/>,
    <Route key={21} path="/Agent/Claim" exact component={PAClaims}/>,
    <Route key={22} path="/Agent/ClientManagement" exact component={PAClientManage}/>,
    <Route key={23} path="/Agent/MaidManagement" exact component={PAMaidManage}/>,
    <Route key={24} path="/Agent/MonthlyPayment" exact component={PAMonthlyPayment}/>,
    <Route key={37} path="/Agent/ACP" exact component={PAACP}/>,
    <Route key={25} path="/User/ChangePassword" exact component={PChangePassword}/>,
    <Route key={26} path="/Insurer/Dashboard" exact component={PIDashboard}/>,
    <Route key={27} path="/Insurer/AllPolicies" exact component={PIAllPolicies}/>,
    <Route key={28} path="/Insurer/Claim" exact component={PIClaims}/>,

    <Route key={30} path="/DCustomer/Profile" exact component={PDCProfile}/>,
    <Route key={31} path="/DCustomer/Dashboard" exact component={PDCDashboard}/>,
    <Route key={32} path="/DCustomer/AllPolicies" exact component={PDCAllPolicies}/>,
    <Route key={33} path="/DCustomer/AccountInfo" exact component={PDCAcountInfo}/>,
    <Route key={34} path="/DCustomer/Claim" exact component={PDCClaims}/>,
    // <Route key={36} path="/DCustomer/MaidManagement" exact component={PDCMaidManage}/>,
    <Route key={35} path="/ConfirmPolicy" exact component={PConfirmPolicy} />,
    
  ];
}

function renderTest() {
  if (process.env.NODE_ENV === "production") return;
  return [
    <Route key={0} path="/Test/Calendarizo" exact component={CalendarizoTest} />,
    <Route key={1} path="/Test/Markdown" exact component={MarkdownTest} />,
  ];
}

function renderIZOSystem(){
  return [
    <Route key={0} path="/StartUp" exact component={StartUp} />,
    <Route key={1} path="/Denied" exact component={Denied} />,
  ];
}

GState.CLEAN();
// if(GState.isLoggedIn()){
//   Env.CheckInitialized();
// }

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <BrowserRouter>
      <Overlay>
        <Container>
          <Switch>
            <Route path="/" exact component={Landing} />
              {renderIZOSystem()}
              {renderPages()}
              {renderTest()}
            <Route component={NoMatch} />
          </Switch>
        </Container>
      </Overlay>
    </BrowserRouter>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
